import { Component } from 'react';
import { Link } from "react-scroll";
import { Translation } from "react-i18next";
import './side-navigation.scss'
import * as constants from '../../helpers/constants'
import { peopleIcon, logoIcon, buildingIcon, companyInfoIcon, paymentsIcon, documentIcon } from '../../images'
import { Configuration } from '../../types/Configuration';

type Props = {
    configuration: Configuration
    selectedLanguage: string
    companyName: string | undefined
    isMainCompany: boolean
    userTeam: string
    companyType: string
    isMobile: boolean
    showInvoices: boolean
}

type State = {
    open: boolean
}

class SideNavigation extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        // Initial state
        this.state = { open: false };
    }

    toggle() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        const desktopScrollToLink = -183;
        const isAdminOrManager = this.props.userTeam == constants.ADMIN_TEAM_ID || this.props.userTeam == constants.MANAGEMENT_TEAM_ID;
        const isAdmin = this.props.userTeam == constants.ADMIN_TEAM_ID;
        return (
            <div className="my-company-side-navigation-container">
                <div className="sm-devices-menu">
                    <button onClick={this.toggle.bind(this)} className="menu-button"><span className="material-icons burger-menu-ico">menu</span></button>
                    <h4>{this.props.companyName}</h4>
                </div>
                <div className={"main-menu" + (this.state.open ? " open" : "")}>
                    <button className="close-button" onClick={this.toggle.bind(this)}><span className="material-icons">close</span></button>
                    <div className='my-company-name'>
                        <div className='company-logo-wraper'>
                            <img src={buildingIcon} alt="" />
                        </div>
                        <span>{this.props.companyName}</span>
                    </div>
                    <hr />
                    <div>
                        <Link
                            to="company-master-data"
                            offset={desktopScrollToLink}
                            spy={true}
                            smooth={true}
                            duration={500}
                            lang={this.props.selectedLanguage}
                        >
                            <img src={companyInfoIcon} alt="" />
                            <span><Translation>{t => t("Information")}</Translation></span>
                        </Link>
                    </div>
                    <div>
                        {isAdmin ? <Link
                            to="people-area"
                            offset={this.props.isMobile ? -460 : -430}
                            spy={true}
                            smooth={true}
                            duration={500}
                            lang={this.props.selectedLanguage}
                        >
                            <img src={logoIcon} alt="" />
                            <span><Translation>{t => t("Logo")}</Translation></span>
                        </Link> : null}
                    </div>
                    <div>
                        {isAdminOrManager ? <Link
                            to="people-area"
                            offset={desktopScrollToLink}
                            spy={true}
                            smooth={true}
                            duration={500}
                            lang={this.props.selectedLanguage}
                        >
                            <img src={peopleIcon} alt="" />
                            <span><Translation>{t => t("People")}</Translation></span>
                        </Link> : null}

                    </div>
                    <div>
                        {this.props.configuration.shouldShowPaymentMethods
                            && isAdmin
                            && (this.props.companyType == constants.COMPANY_TYPE.DIRECT_CUSTOMER || this.props.companyType == constants.COMPANY_TYPE.PARTNER)
                            && <Link
                                to="payment-methods"
                                offset={desktopScrollToLink}
                                spy={true}
                                smooth={true}
                                duration={500}
                                lang={this.props.selectedLanguage}
                            >
                                <img src={paymentsIcon} alt="" />
                                <span><Translation>{t => t("Payments")}</Translation></span>
                            </Link>}
                    </div>
                    <div>
                        {this.props.configuration.shouldShowInvoices
                            && isAdmin 
                            && this.props.isMainCompany
                            && this.props.showInvoices
                            && <Link
                                to="invoices-area"
                                offset={desktopScrollToLink}
                                spy={true}
                                smooth={true}
                                duration={500}
                                lang={this.props.selectedLanguage}>
                                    <img src={documentIcon} alt="" />
                                    <span><Translation>{t => t("Invoices/Credit Memo")}</Translation></span>
                                </Link>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default SideNavigation;